import { magicNumbers } from 'utils';

export const instagramInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    platform: 'instagram',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    isDisabled: true,
    hasActivateSwitch: true,
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'instagram',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'instagram',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'instagram',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  ageFilter: {
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'ageFilter',
    translateKey: 'filter:ageRange',
    hasActivateSwitch: true,
  },
  genderFilter: {
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'genderFilter',
    translateKey: 'filter:gender',
    hasActivateSwitch: true,
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    hasActivateSwitch: true,
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      like: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:likeCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      comment: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:commentCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
    isDisabled: true,
    hasActivateSwitch: true,
    openSubCategories: true,
  },
};
